// Global navigation / high-level app state.
import { create } from "zustand";

export const SCREEN = {
    INTRO: "intro",
    MENU: "menu",       // Home / Lobby
    PLAY: "play",
    SETTINGS: "settings",
    PROFILE: "profile",
    INVENTORY: "inventory",
    LOADOUT: "loadout",
    STORE: "store",
    NEWS: "news",
    FRIENDS: "friends",
    RECORDINGS: "recordings",
    CAREER: "career",
    STATISTICS: "statistics",
    MATCH: "match",
};

export const useGameStore = create((set) => ({
    screen: SCREEN.INTRO,
    goto: (screen) => set({ screen }),

    matchConfig: null,
    setMatchConfig: (matchConfig) => set({ matchConfig }),

    lastMatch: null,
    setLastMatch: (lastMatch) => set({ lastMatch }),
}));
